import database from 'database'

class Utilities {
  async localDelete (list, item) {
    let localBackup = list
    for (let i = 0; i < list.length; i++) {
      if (list[i].code === item.code && list[i].appId === item.appId) {
        localBackup.splice(i, 1)
        break
      }
    }
    return localBackup
  }

  customFilter (data, list) {
    let filteredData

    if (data && data.length > 0) {
      filteredData = []

      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < data.length; j++) {
          for (let z = 0; z < data[j].data.length; z++) {
            if (list[i][data[j].field] === data[j].data[z]) {
              filteredData.push(list[i])
            }
          }
        }
      }
    } else {
      filteredData = list
    }

    return filteredData
  }

  clearDatabase () {
    database.User.clear()
    database.UserSession.clear()
    database.Settings.clear()
    database.TableSettings.clear()
    location.reload()
  }
}

export default new Utilities()
